window.onload = function() {
    if (document.querySelector('.nfa-hero')) {
      var logoElements = document.querySelectorAll('.main-header__logo');
      logoElements.forEach(function(logoElement) {
        logoElement.style.opacity = '0';
        logoElement.style.height = '0';
      });
    }
  };